import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseCommentFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75055 21.0953C8.29559 21.9887 10.0898 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20099 1.5 1.49998 6.20101 1.49998 12C1.49998 13.8091 1.95864 15.5143 2.76628 17.0025C2.42325 17.6597 1.97057 18.2519 1.43188 18.7545C1.01968 19.139 0.857853 19.7221 1.01297 20.2641C1.16809 20.806 1.61395 21.2152 2.16718 21.3234C2.76117 21.4396 3.37387 21.5002 3.99928 21.5002C4.9542 21.5002 5.87828 21.3589 6.75055 21.0953ZM7.99998 13.25C8.69034 13.25 9.24998 12.6904 9.24998 12C9.24998 11.3096 8.69034 10.75 7.99998 10.75C7.30963 10.75 6.74998 11.3096 6.74998 12C6.74998 12.6904 7.30963 13.25 7.99998 13.25ZM12 13.25C12.6903 13.25 13.25 12.6904 13.25 12C13.25 11.3096 12.6903 10.75 12 10.75C11.3096 10.75 10.75 11.3096 10.75 12C10.75 12.6904 11.3096 13.25 12 13.25ZM17.25 12C17.25 12.6904 16.6903 13.25 16 13.25C15.3096 13.25 14.75 12.6904 14.75 12C14.75 11.3096 15.3096 10.75 16 10.75C16.6903 10.75 17.25 11.3096 17.25 12Z"
        fill={color}
      />
    </svg>
  );
};
